<template>
  <table class="table table-nowrap table-responsive">
    <thead>
    <tr>
      <th class="table-title text-center" translate="no">ID</th>
      <th class="table-title text-center"></th>
      <th class="table-title text-center">Nome</th>
      <th class="table-title text-center">Permissão</th>
      <th class="table-title text-center"></th>
      <th class="table-title text-center"></th>
    </tr>
    </thead>
    <TableBodySkeleton
      v-if="isLoadingUsers"
      :rows="10"
      :columns="[
        { type: 'text', width: '60px' },
        { type: 'circle', size: '40px' },
        { type: 'text', width: '90%' },
        { type: 'badge', width: '100px' },
        { type: 'actions', count: 1, actionWidth: '30px', actionHeight: '30px' },
        { type: 'actions', count: 1, actionWidth: '30px', actionHeight: '30px' }
      ]"
    />
    <tbody v-else class="text-base">
    <tr
        v-for="(user, index) in users"
        :key="index"
        >
      <td class="text-center">{{ user.id }}</td>
      <td class="avatar-td">
        <div class="table-avatar-container">
          <AvatarCard v-if="user?.avatar" :avatarException="user.avatar" :userId="user?.id" />
        </div>
      </td>
      <td class="text-center">
          {{ user.name }}
          <i v-if="user?.test_user" class="bi me-2 bi-person-fill-gear"></i>
      </td>
      <td class="text-center">{{ getType(user.type) }}</td>
      <td class="text-center">
        <i class="bi bi-pencil-square regular-icon" @click.stop="open(user)"></i>
      </td>
      <td class="text-center">
        <i class="bi bi-trash delete-icon" @click.stop="confirmDelete(user.id)"></i>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
import AvatarCard from '../cards/AvatarCard.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import TableBodySkeleton from '../skeletons/TableBodySkeleton.vue';


export default {
  name: 'UsersCard',

  components: {
    TableBodySkeleton,
    AvatarCard
  },

  props: {
    users: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const store = useStore();
    const isLoadingUsers = computed(() => store.getters['skeleton/getSkeletonLoadingState']('usersTable'));

    return {
      isLoadingUsers
    };
  },

  methods: {
    open(user) {
      this.$emit('open', user);
    },

    confirmDelete(id) {
      this.$emit('confirmDelete', id);
    },

    getType(type) {
      if (typeof type === 'object') {
        return type.map((item) => this.getType(item)).join(', ');
      }

      switch (type) {
        case 'manager':
          return 'Gestor';
        case 'client':
          return 'Cliente';
        case 'student':
          return 'Aluno';
        case 'tutor':
          return 'Tutor';
        case 'supervisor':
          return 'Supervisor';
        case 'admin':
          return 'Administrador';
        case 'teacher':
          return 'Professor';
        default:
          return 'Usuário';
      }
    },
  }
}
</script>
<style scoped>
.table {
  --bs-table-color: var(--gray-1);
  --bs-table-border-color: var(--blue-4);
}

.thead-light {
  background-color: var(--gray-4);
}

th, td {
  vertical-align: middle;
}

.table td:nth-child(3),
.table th:nth-child(3),
.table td:nth-child(4),
.table th:nth-child(4) {
  width: 40%;
}

.table td:nth-child(1),
.table th:nth-child(1)
.table th:nth-child(2)
.table td:nth-child(2) {
  width: 10%;
}

.table td:nth-child(5),
.table th:nth-child(5),
.table td:nth-child(6),
.table th:nth-child(6) {
  width: 5%;
}
</style>